/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Purpose_1Inputs */

const da_privacy_purpose_1 = /** @type {(inputs: Privacy_Purpose_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At levere tjenesten, din konto og dit abonnement, og at behandle din anmodning om adgang til betaen: aftale eller skridt forud for en aftale (databeskyttelsesforordningens art. 6, stk. 1, litra b).`)
};

/** @type {(inputs: Privacy_Purpose_1Inputs) => LocalizedString} */
const en_privacy_purpose_1 = da_privacy_purpose_1;

/**

* @param {Privacy_Purpose_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_purpose_1 = /** @type {((inputs?: Privacy_Purpose_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Purpose_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_purpose_1(inputs)
	return /** @type {LocalizedString} */ ("At levere tjenesten, din konto og dit abonnement, og at behandle din anmodning om adgang til betaen: aftale eller skridt forud for en aftale (databeskyttelsesforordningens art. 6, stk. 1, litra b).")
});